
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import "./styles.css";
import { connect } from "react-redux";
import { EntryModalOption } from '../../components';
import { getPortfolioRowClassName, toggleRowSelected } from 'utils/tableRowSelect';

const stylesLocal = {
    subcell: {
        padding: "5px",
    },
    cell: {
        padding: "5px",
    }
};

const SubRow = props => {
    const { subItem, name, isAtmBoundary, isAtm } = props;
    const [selected, setSelected] = useState(false);

    const rowClass = [
        getPortfolioRowClassName(selected),
        isAtmBoundary ? 'trade-strike-row--atm-boundary' : '',
        isAtm ? 'trade-strike-row--atm' : '',
    ].filter(Boolean).join(' ');

    return (
        <React.Fragment>
            <tr
                className={rowClass}
                onClick={(event) => toggleRowSelected(event, setSelected)}
            >
                <td style={stylesLocal.subcell} align="right">
                    {subItem.call.open_interest}
                </td>
                <td style={stylesLocal.subcell} align="right">
                    {subItem.call.delta}
                </td>
                <td style={stylesLocal.subcell} align="right">
                    {subItem.call.volume}
                </td>
                <td style={stylesLocal.subcell} align="right">
                    {
                        subItem.call.bid && (
                            <EntryModalOption
                                market={"SELL"}
                                option_kind={"CALL"}
                                strike_price={subItem.strike_price}
                                name={name}
                                symbol={subItem.ticker}
                                expire_at={subItem.expiration_date}
                                price={subItem.call.bid.toFixed(2)}
                            />
                        )
                    }
                </td>
                <td style={stylesLocal.subcell} align="right">
                    {
                        subItem.call.ask && (
                            <EntryModalOption
                                market={"BUY"}
                                option_kind={"CALL"}
                                strike_price={subItem.strike_price}
                                name={name}
                                symbol={subItem.ticker}
                                expire_at={subItem.expiration_date}
                                price={subItem.call.ask.toFixed(2)}
                            />
                        )
                    }
                </td>
                <td
                    className={[
                        'trade-strike-cell',
                        isAtm ? 'trade-strike-cell--atm' : '',
                    ].filter(Boolean).join(' ')}
                    align="center"
                >
                    {Number(subItem.strike_price).toFixed(2)}
                    {isAtm ? <span className="trade-strike-atm-tag">ATM</span> : null}
                </td>
                <td style={stylesLocal.subcell} align="right">
                    {
                        subItem.put.bid && (
                            <EntryModalOption
                                market={"SELL"}
                                option_kind={"PUT"}
                                strike_price={subItem.strike_price}
                                name={name}
                                symbol={subItem.ticker}
                                expire_at={subItem.expiration_date}
                                price={subItem.put.bid.toFixed(2)}
                            />
                        )
                    }
                </td>
                <td style={stylesLocal.subcell} align="right">
                    {
                        subItem.put.ask && (
                            <EntryModalOption
                                market={"BUY"}
                                option_kind={"PUT"}
                                strike_price={subItem.strike_price}
                                name={name}
                                symbol={subItem.ticker}
                                expire_at={subItem.expiration_date}
                                price={subItem.put.ask.toFixed(2)}
                            />
                        )
                    }
                </td>
                <td style={stylesLocal.subcell} align="right">
                    {subItem.put.volume}
                </td>
                <td style={stylesLocal.subcell} align="right">
                    {subItem.put.delta}
                </td>
                <td style={stylesLocal.cell} align="right">
                    {subItem.put.open_interest}
                </td>
            </tr>
        </React.Fragment>
    )
}

SubRow.propTypes = {
    className: PropTypes.string,
    subItem: PropTypes.object,
    name: PropTypes.string,
    isAtmBoundary: PropTypes.bool,
    isAtm: PropTypes.bool,
    spotPrice: PropTypes.number,
};

function mapStateToProps(reducer) {
    return {
        user_id: reducer.session.auth.id,
        token: reducer.session.auth.token,
        listOption: reducer.optionTrade.list,
    };
}

export default connect(mapStateToProps)(SubRow);
